// Timestamps stored as BSON datetimes come back from the API WITHOUT a
// timezone suffix (PyMongo returns naive UTC), so `new Date(s)` would parse
// them as LOCAL time and display the UTC clock reading (4h ahead in EDT).
// ensureUtc appends 'Z' only when no offset is present — already-suffixed
// strings are untouched.
export const ensureUtc = (v) => {
  if (!v) return v;
  const s = String(v);
  return /(Z|[+-]\d{2}:?\d{2})$/.test(s) ? s : `${s}Z`;
};

export const parseUtc = (v) => {
  if (!v) return null;
  const d = new Date(ensureUtc(v));
  return isNaN(d) ? null : d;
};

// Local-timezone display, e.g. "9/5/2026, 3:38:05 PM"
export const formatUtcTimestamp = (v, options) => {
  const d = parseUtc(v);
  if (!d) return v ? String(v) : '';
  return options ? d.toLocaleString('en-US', options) : d.toLocaleString();
};
